import axios from 'axios'
import { ERRORS } from './constant';
import i18n from '../i18n'

const makeFormData = (params) => {
  const form = new window.FormData()
  for (const key of Object.keys(params)) {
    form.append(key, params[key])
  }
  return form
}

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('TOKEN')
  if (token) {
    config.headers['authorization'] = `Bearer ${token}`
  }

  if (config.contentType === 'form-data') {
    config.data = makeFormData(config.data)
  }

  config.headers['x-language'] = i18n.language

  return config
}, (error) => {
  return Promise.reject(error)
})

const isApiEnvelope = (data) => {
  return !!data && typeof data === 'object' && !Array.isArray(data) && Object.prototype.hasOwnProperty.call(data, 'payload')
}

axios.interceptors.response.use((res) => {
  const token = res.headers['x-user-token']
  if (token) {
    localStorage.setItem('TOKEN', token)
  }

  if (!isApiEnvelope(res.data)) {
    window.sentry.addBreadcrumb({
      category: 'xhr-unknown-exception',
      message: `invalid api envelope: ${typeof res.data}`,
      level: 'error'
    })
    return Promise.reject(i18n.t('error.xhrUnknownException'))
  }

  if (res.data.errorCode === ERRORS.CM0004) {
    localStorage.removeItem('TOKEN')
    window.location.href = '/signin'
  }

  return res.data
}, (error) => {
  if (error.response) {
    return Promise.reject(`${error.response.status}:${error.response.statusText}`)
  } else {
    window.sentry.addBreadcrumb({
      category: 'xhr-unknown-exception',
      message: `${error}`,
      level: 'error'
    });
    if (error.message && error.message.includes('Network')) {
      return Promise.reject(i18n.t('error.networkConnectionException'))
    }

    return Promise.reject(i18n.t('error.xhrUnknownException'))
  }
})

export default axios
